module.exports = __webpack_public_path__ + "img/fleerun-sm.2304ffa0.png";